
import React, { useEffect, useState } from 'react';
import './SuperAdminDashboard.css';
import ScreenLoader from '../../HtmlElements/ScreenLoader';
import useAuth from '../../../hooks/useAuth';
import { useUser } from '../../../context/UserContext';
import Users from '../../Users/Users';
import { Navigate } from 'react-router-dom';
import api from '../../../services/api';

import AdminStats from './AdminStats';
import AdminCharts from './AdminCharts';
import AdminActivity from './AdminActivity';

const SuperAdminDashboard = () => {
    useAuth();
    const { user, handleLogout } = useUser();
    const [statsData, setStatsData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            if (user) {
                try {
                    const response = await api.get('/admin/dashboard_stats');
                    if (response.data && response.data.status === 200) {
                        console.log("Admin Stats Data:", response.data.result);
                        setStatsData(response.data.result);
                    }
                } catch (error) {
                    console.error("Error fetching admin stats:", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        if (user) {
            fetchStats();
        }
    }, [user]);

    if (!user) {
        return <ScreenLoader />;
    }

    // Assuming role_key 24 is Super Admin
    const isSuperAdmin = user?.role_key === 'SUPER_ADMIN' || parseInt(user?.role) === 24;

    if (!isSuperAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    if (loading) {
        return <ScreenLoader />;
    }

    return (
        <div className="super-admin-dashboard">
            <div className="admin-header d-flex justify-content-between align-items-center mb-4">
                <h2 className="text-dark fw-bold m-0">Super Admin Overview</h2>
                <button
                    className="btn btn-outline-danger"
                    onClick={() => handleLogout('/admin')}
                >
                    <i className="fas fa-sign-out-alt me-2"></i> Logout
                </button>
            </div>

            {/* 1. Stats Cards */}
            <AdminStats stats={statsData?.stats} />

            {/* 2. Charts & Activity Log Grid */}
            <div className="dashboard-content-grid">
                <AdminCharts chartData={statsData?.chart_data} />
                <AdminActivity activity={statsData?.recent_activity} />
            </div>

            {/* 3. User Management */}
            <div className="users-section mt-4">
                <div className="admin-users-card">
                    <h3>User Management</h3>
                    <Users isEmbedded={true} />
                </div>
            </div>
        </div>
    );
};

export default SuperAdminDashboard;
